var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-recaptcha',{ref:"invisibleHcaptcha",attrs:{"loadRecaptchaScript":true,"sitekey":_vm.getEnvCaptcha()},on:{"verify":_vm.changeVerify}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }